import { toast } from "sonner";

import { OutgoingIntakesAPI } from "@/api/outgoingIntakesApi";

/** Fetch the intake's current public link and put it on the clipboard. */
export const copyIntakeLink = async (
  clientId: string,
  intakeId: string
): Promise<void> => {
  try {
    const { public_link } = await OutgoingIntakesAPI.getLink(
      clientId,
      intakeId
    );
    await navigator.clipboard.writeText(public_link);
    toast.success("Link copied");
  } catch (e) {
    toast.error(e instanceof Error ? e.message : "Couldn't copy the link");
  }
};

/**
 * Shown whenever the server reports `email_delivered: false`: the link exists
 * and works, the email just didn't go out, so offer to copy it.
 */
export const toastEmailFailed = (clientId: string, intakeId: string) =>
  toast.warning("Link created, but the email failed", {
    description: "Copy the link and send it to your client yourself.",
    duration: 12000,
    action: {
      label: "Copy link",
      onClick: () => void copyIntakeLink(clientId, intakeId)
    }
  });
